module.exports = __webpack_public_path__ + "img/slide3.81b0aaae.png";